import { render, staticRenderFns } from "./CompanyDesktopEmployees.vue?vue&type=template&id=48c048b7"
import script from "./CompanyDesktopEmployees.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports